module.exports = __webpack_public_path__ + "img/ic_bed_handh.056f8c94.png";